__turbopack_context__.v({
  "content": "BoardSectionItemTeaser-module-scss-module__WV7Ysa__content",
  "header": "BoardSectionItemTeaser-module-scss-module__WV7Ysa__header",
  "isLargeWrapper": "BoardSectionItemTeaser-module-scss-module__WV7Ysa__isLargeWrapper",
  "meta": "BoardSectionItemTeaser-module-scss-module__WV7Ysa__meta",
  "teaserIcon": "BoardSectionItemTeaser-module-scss-module__WV7Ysa__teaserIcon",
  "title": "BoardSectionItemTeaser-module-scss-module__WV7Ysa__title",
  "wrapper": "BoardSectionItemTeaser-module-scss-module__WV7Ysa__wrapper",
});
